<template>
  <div class="action copy-amazon-link" @click="openLink">View On Amazon</div>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: "ViewOnAmazon",
  props: ["assignment"],
  emits: ["clicked"],
  computed: {
    ...mapState({
      user: "user",
      allowedCountries: "allowedCountries"
    }),
    amazonLink() {
      if (!this.assignment.book.web_url) {
        return generateAmazonLink(this.assignment.book)
      }
      let linkDomain = "amazon.com"
      let userDomain = "amazon.com"
        this.allowedCountries.forEach((country) => {
          if (country.country_code === this.user.country_code) {
            userDomain = country.amazon_domain
           }
          if (this.assignment.book.web_url.indexOf(country.amazon_domain) > 0) {
            linkDomain = country.amazon_domain
          }
        })

        return this.assignment.book.web_url.replace(linkDomain, userDomain)
    }
  },
  methods: {
    copyLink() {
      const link = generateAmazonLink(this.assignment.book);
      const command = isMacintosh() ? "Command+V" : "Ctrl+V";

      let message = "";

      if (link.indexOf("http") !== -1) {
        message =
          "Your Amazon link is ready! Open a new tab and paste (" +
          command +
          ") into the search box to view the book.";
      } else {
        message =
          "Your Amazon search is ready! Go to Amazon and paste (" +
          command +
          ") into the search box to find the book.";
      }

      this.$toasted.show(message, {
        icon: "link",
        position: "bottom-center",
        duration: 6000
      });

      copyToClipboard(link);
    },
    openLink() {
      window.open(this.amazonLink, '_blank');
      this.$emit("clicked")
    },
    handleClick() {
      this.copyLink();
    }
  }
};

function generateAmazonLink(book) {
  let link = "";
  const title = book.amazon_search_title;
  const author = book.amazon_search_author;

  if (!title || !author) {
    return book.web_url;
  }

  // Decide if title or author should come first.
  if (getRandomInt(2)) {
    const by = getRandomInt(2) ? " by" : "";
    link = title + by + " " + author;
  } else {
    link = author + " " + title;
  }

  // Decide if lowercase or title case.
  if (getRandomInt(2)) {
    link = link.toLowerCase();
  } else {
    link = toTitleCase(link);
  }

  // Decide if "book" or "ebook" suffix should be included.
  if (getRandomInt(2)) {
    if (book.manuscript_file_url.indexOf(".epub") !== -1) {
      if (getRandomInt(2)) {
        link += " kindle";
      } else {
        link += "ebook";
      }
    } else {
      link += " book";
    }
  }

  return link;
}

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function isMacintosh() {
  return navigator.platform.indexOf("Mac") > -1;
}

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.copy-amazon-link {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
}
</style>



